import { getCategoryLabel, getCategorySlogan } from "../../app/enums/category.enum";
import { APP_PATHS } from "../../app/constants/routes.constants";

// Configuración de las maravillas del home
// OBJECTID: ID del elemento de ejemplo a mostrar
// group: Identificador de la maravilla (M1-M6)
// code: código de categoría para obtener titulo y subtitle del enum
interface MaravillaConfig {
    OBJECTID: number;
    group: string;
    code: string;
}

const MARAVILLAS_CONFIG: MaravillaConfig[] = [
    { OBJECTID: 32, group: 'M1', code: 'arq' },
    { OBJECTID: 2, group: 'M2', code: 'playa' },
    { OBJECTID: 2, group: 'M3', code: 'pueblo' },
    { OBJECTID: 2, group: 'M4', code: 'natural' },
    { OBJECTID: 1, group: 'M5', code: 'sendero' },
    { OBJECTID: 36, group: 'M6', code: 'evento' },
    { OBJECTID: 1, group: 'M7', code: 'alojamiento' }
];

// Genera las categorías usando el enum para titulo y subtitle (translation keys)
export const CATEGORIES = MARAVILLAS_CONFIG.map(m => ({
    OBJECTID: m.OBJECTID,
    group: m.group,
    code: m.code,
    tituloKey: getCategoryLabel(m.code),
    sloganKey: getCategorySlogan(m.code),
    route: m.code === 'alojamiento' ? [APP_PATHS.ACCOMMODATIONS] : [APP_PATHS.WONDERS],
    queryParams: m.code === 'alojamiento' ? {} : { category: m.code }
}));
